<template>
  <div>
      <banner-top :text="titletext"></banner-top>
      <div class="bg"></div>
      <div v-if="res.students">
        <div v-for="item in res.students" :key="item.id">
          <div class="student">
            <div style="font-size: 18px;">{{item.name}}</div>
            <div class="content">
              <!-- {{item.school}}, -->
              <!-- {{item.classroom}}， -->
              {{item.gender==1?'男': '女'}}，
              联系电话{{item.phone}}，
              身份证号{{item.id_no}}
            </div>
            <el-divider></el-divider>
            <div class="handle">
                <div @click="addDefault(item.id)" v-if="!item.is_default" >
                    <img src="../assets/icon34.png" alt="">
                    <span class="checkSpan">设为默认</span>
                </div>
                <div v-if="item.is_default">
                    <img src="../assets/icon33.png" alt="">
                    <span class="checkSpan yellow">当前默认</span>
                </div>
                <div style="display:flex;">
                    <div @click="change(item)">
                        <img src="../assets/icon35.png" alt="">
                        <span class="handleSpan">编辑</span>
                    </div>
                    <div @click="del(item.id)">
                        <img src="../assets/icon36.png" alt="">
                        <span class="handleSpan">删除</span>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="noneClass">
        目前没有学生
      </div>
    <div class="nav">
        <button><router-link to="/addStudents">添加</router-link></button>
    </div>
  </div>
</template>

<script>
import bannerTop from '../components/BannerTop.vue'
import http from '../utils/http'

export default {
  name: 'studentsInfo',
  components: { bannerTop },
  data () {
    return {
      checked: true,
      titletext: '我的学生信息',
      res: Object
    }
  },
  methods: {
    change (item) {
      this.$router.push({name: 'changeStudents', query: {item: item}})
    },
    del (id) {
      this.$confirm('删除该学生信息?', {
        confirmButtonText: '确定',
        cancelButtonText: '我再想想',
        type: 'warning',
        customClass: 'winClass'
      }).then(() => {
        http['delete'](`students/${id}`)
        http['get']('students').then((res) => {
          this.students = res
        })
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    addDefault (id) {
      http['put'](`students/${id}/default`)
      http['get']('students').then((res) => {
        this.res = res
      })
    }
  },
  created () {
    http['get']('students').then((res) => {
      this.res = res
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
    position: absolute;
    width: 100%;
    height: 110%;
    top: -10%;
    background: #f5f5f5;
    z-index: -1;
}
.student {
  margin: 0.8rem;
  border-radius: 10px;
  background: #fff;
  padding: 0.8rem;
}
.content {
  color: #666;
  word-break: break-all;
  word-wrap: break-word
}
.el-divider {
    margin: 0.8rem 0;
}
.studentCheck {
  position: absolute;
  width: 1.2rem;
  right: 1.7rem;
}
.handle {
    display: flex;
    color: #666;
    justify-content: space-between;
}
.checkSpan {
    position: relative;
    top: -0.25rem;
}
.yellow {
    color: #ffb949;
}
.handleSpan{
    font-size: 14px;
    position: relative;
    top: -0.4rem;
}
.handle div img{
    width: 1.3rem;
    margin-left: 1rem;
}
.nav {
  width: 100%;
  height: 3.2rem;
  display: flex;
  position:fixed;
  justify-content: center;
  bottom: 0;
}
.nav button {
    width: 80%;
    height: 2.8rem;
    background: #ffb949;
    border-radius: 44px;
    border: 0;
    color: #fff;
    font-size: 18px;
}
</style>
<style>
.winClass {
  width: 60%!important;
}
</style>



// WEBPACK FOOTER //
// src/mine/studentsInfo.vue